import { render, staticRenderFns } from "./testCreation.vue?vue&type=template&id=f5d609c2&scoped=true"
import script from "./testCreation.vue?vue&type=script&lang=js"
export * from "./testCreation.vue?vue&type=script&lang=js"
import style0 from "./testCreation.vue?vue&type=style&index=0&id=f5d609c2&prod&lang=scss"
import style1 from "./testCreation.vue?vue&type=style&index=1&id=f5d609c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d609c2",
  null
  
)

export default component.exports